import apiClient from "./axios"

export const getVehicleDailyAudits = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-daily-audits", { params })
  return data
}

export const getVehicleDailyAudit = async id => {
  const { data } = await apiClient.get(`/vehicle-daily-audits/${id}`)
  return data
}

export const getVehicleDailyAuditReport = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-daily-audits/report", { params })
  return data
}

export const getVehiclesByLastLocation = async locationId => {
  const { data } = await apiClient.get("/vehicle-daily-audits/vehicles-by-location", {
    params: { location_id: locationId },
  })
  return data
}

export const closeVehicleDailyAudit = async payload => {
  const { data } = await apiClient.post("/vehicle-daily-audits", payload)
  return data
}

export const reopenVehicleDailyAudit = async ({ id, reason }) => {
  const { data } = await apiClient.post(`/vehicle-daily-audits/${id}/reopen`, { reason })
  return data
}
